import React from 'react';
import PropTypes from 'prop-types';

import DuplicationForm from './duplication_form';

export class DuplicatePropertyButton extends React.Component {
  static propTypes = {
    propertyId: PropTypes.number.isRequired,
    propertyTitle: PropTypes.string.isRequired,
  }

  state = {
    isOpen: false
  }

  openModal = () => this.setState({ isOpen: true });
  closeModal = () => this.setState({ isOpen: false });

  render() {
    return (
      <React.Fragment>
        <a name="duplicatePropertyLink" onClick={this.openModal}>Duplicate Property</a>

        <DuplicationForm 
          propertyId={this.props.propertyId}
          propertyTitle={this.props.propertyTitle}
          show={this.state.isOpen}
          onHide={this.closeModal}
        /> 
      </React.Fragment>
    );
  }
}

export default DuplicatePropertyButton;
